import React from 'react';
import { makeStyles } from '@mui/styles';
import { Section, SectionAlternate } from 'components/organisms';

import {
  Browsers,
  Contact,
  Features,
  HeroSection,
  HowItWorks,
  HowLokeyWorks,
  Integrations,
  OneStopSolution,
  Partners,
  SolutionForYourNeed,
  Solutions,
  Subscription,
  TechnologyPartner,
  VideoSection,
  Webinars,
  WhatIsLokey,
} from './components';

import {
  onboardingSteps,
  techPartner,
  partners,
  features,
  browsers,
  advantages,
  webinars,
  platforms,
} from './data';

const useStyles = makeStyles(theme => ({
  pagePaddingTop: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(1),
    },
  },
  sectionAlternate: {
    background: 'transparent',
    backgroundImage: `linear-gradient(180deg, ${theme.palette.background.paper} 40%, ${theme.palette.primary.dark} 0%)`,
  },
}));

const Home = () => {
  const classes = useStyles();

  return (
    <div>
      {/* <Section className={classes.pagePaddingTop}> */}
      <HeroSection />
      {/* </Section> */}
      <Section className={classes.pagePaddingTop}>
        <OneStopSolution />
      </Section>
      <SectionAlternate className={classes.pagePaddingTop}>
        <SolutionForYourNeed />
      </SectionAlternate>

      <Section className={classes.pagePaddingTop}>
        <HowItWorks data={onboardingSteps}/>
      </Section>
      <SectionAlternate className={classes.pagePaddingTop}>
        <TechnologyPartner data={techPartner}/>
      </SectionAlternate>
      <Section id="home-contact" className={classes.pagePaddingTop}>
        <Contact />
      </Section>
      {/* <SectionAlternate className={classes.pagePaddingTop}>
        <VideoSection />

      </SectionAlternate> */}


      {/*    <SectionAlternate>
        <Solutions data={features} />
      </SectionAlternate>
      <Section>
        <>
        <Browsers data={browsers} />
        <Section>
          <Divider />
        </Section>
        <Features data={advantages} />
        </>
      </Section>
      <SectionAlternate innerNarrowed>
        <Webinars data={webinars} />
      </SectionAlternate>
      <Section>
        <Integrations data={platforms} />
      </Section> */}
      {/* <SectionAlternate innerNarrowed className={classes.sectionAlternate}>
        <Subscription />
      </SectionAlternate> */}
    </div>
  );
};

export default Home;
